import React from "react";
import moment from "moment";
const format1 = "DD MMMM YYYY"

export const WPDateColumnFormatter = (cellContent, row) => (
  <span>{moment(row.pulgin_install_date).format(format1)}</span>
);
